import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "card mb-25 border-0 rounded-0 bg-white add-besc-card shadow-sm" }
const _hoisted_3 = { class: "card-body p-15 p-sm-20 p-md-30 letter-spacing" }
const _hoisted_4 = { class: "border border-primary rounded-3 shadow-sm overflow-hidden" }
const _hoisted_5 = {
  class: "row d-flex align-items-center justify-content-between fw-bold py-3 px-4 m-0",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_6 = { class: "col-md-5 text-end" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "p-4" }
const _hoisted_9 = { class: "col-md-5" }
const _hoisted_10 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_11 = { class: "col-md-5" }
const _hoisted_12 = ["onChange"]
const _hoisted_13 = {
  key: 0,
  class: "text-success d-block mt-2"
}
const _hoisted_14 = {
  key: 1,
  class: "text-danger d-block mt-1"
}
const _hoisted_15 = { class: "col-md-2 text-center" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 1,
  class: "text-muted small"
}
const _hoisted_18 = {
  key: 0,
  class: "text-center text-muted py-4"
}
const _hoisted_19 = {
  key: 0,
  class: "text-danger mt-3 fw-bold"
}
const _hoisted_20 = { class: "d-flex justify-content-between align-items-center mt-5 pt-4 border-top" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "modal-backdrop fade show"
}
const _hoisted_23 = {
  key: 1,
  class: "modal fade show d-block",
  tabindex: "-1",
  style: {"z-index":"1050"}
}
const _hoisted_24 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_25 = {
  class: "modal-content overflow-hidden",
  style: {"border-radius":"20px","box-shadow":"0 25px 50px rgba(0, 0, 0, 0.15)"}
}
const _hoisted_26 = { class: "payment-modal-container" }
const _hoisted_27 = { class: "payment-header" }
const _hoisted_28 = { class: "amount-display" }
const _hoisted_29 = { class: "px-4 pb-4" }
const _hoisted_30 = { class: "alert alert-info mb-4" }
const _hoisted_31 = { class: "mb-2" }
const _hoisted_32 = { class: "row small" }
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = { class: "mb-1" }
const _hoisted_35 = { class: "mb-1" }
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = { class: "mb-1" }
const _hoisted_38 = {
  key: 0,
  class: "alert alert-success small p-3 mb-4"
}
const _hoisted_39 = { class: "payment-methods-grid" }
const _hoisted_40 = { class: "payment-method-desc" }
const _hoisted_41 = {
  key: 1,
  class: "alert alert-warning mt-4"
}
const _hoisted_42 = { class: "text-center mt-5" }
const _hoisted_43 = {
  key: 2,
  class: "modal-backdrop fade show"
}
const _hoisted_44 = {
  key: 3,
  class: "modal fade show d-block",
  tabindex: "-1"
}
const _hoisted_45 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_46 = { class: "modal-content" }
const _hoisted_47 = { class: "modal-body text-center p-4" }
const _hoisted_48 = { class: "d-flex flex-column gap-3" }
const _hoisted_49 = ["disabled"]
const _hoisted_50 = {
  key: 0,
  class: "fa fa-spinner fa-spin me-2"
}
const _hoisted_51 = {
  key: 1,
  class: "fa fa-print me-2"
}
const _hoisted_52 = ["disabled"]
const _hoisted_53 = {
  key: 0,
  class: "fa fa-spinner fa-spin me-2"
}
const _hoisted_54 = {
  key: 1,
  class: "fa fa-file-invoice-dollar me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StepProgressTracker = _resolveComponent("StepProgressTracker")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_StepProgressTracker, {
        "current-step": 'step3',
        "besc-id": _ctx.bescId
      }, null, 8, ["besc-id"]),
      _cache[14] || (_cache[14] = _createElementVNode("div", {
        class: "card-header d-flex justify-content-between align-items-center py-4 px-4",
        style: {"background-color":"#0a59a4"}
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("h3", { class: "text-white fw-bold mb-1" }, "Étape 3/4 – Documents & Validation finale"),
          _createElementVNode("small", { class: "text-white opacity-75" }, "Téléversez les documents nécessaires et validez le BESC")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col-md-7" }, [
              _createElementVNode("h5", { class: "text-white mb-0" }, "Pièce(s) jointe(s)")
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-light btn-sm shadow-sm",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addPiece && _ctx.addPiece(...args))),
                disabled: !_ctx.canAddPiece
              }, " Ajouter une pièce ", 8, _hoisted_7)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[11] || (_cache[11] = _createStaticVNode("<div class=\"row gx-3 mb-3 fw-bold text-muted small\" data-v-4a83da13><div class=\"col-md-5\" data-v-4a83da13>TYPE DE DOCUMENT</div><div class=\"col-md-5\" data-v-4a83da13>FICHIER</div><div class=\"col-md-2 text-center\" data-v-4a83da13>ACTION</div></div><hr class=\"mt-0 mb-4\" data-v-4a83da13>", 2)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pieces, (piece, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "row gx-3 align-items-center mb-3 pb-3 border-bottom"
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_Multiselect, {
                    modelValue: piece.type_id,
                    "onUpdate:modelValue": ($event: any) => ((piece.type_id) = $event),
                    options: _ctx.typeDocuments,
                    placeholder: "Sélectionner le type",
                    label: "label",
                    "track-by": "value",
                    loading: _ctx.loading,
                    class: _normalizeClass({ 'border-danger': !piece.type_id && index < _ctx.pieces.length - 1 })
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "loading", "class"]),
                  (!piece.type_id && index < _ctx.pieces.length - 1)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_10, " Type de document requis "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("input", {
                    type: "file",
                    class: _normalizeClass(["form-control shadow-sm", { 'border-danger': !piece.fichier && index < _ctx.pieces.length - 1 }]),
                    onChange: e => _ctx.handleFile(e, index),
                    accept: '.pdf'
                  }, null, 42, _hoisted_12),
                  (piece.filename)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_13, _toDisplayString(piece.filename), 1))
                    : (!piece.fichier && index < _ctx.pieces.length - 1)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_14, " Fichier requis "))
                      : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  (index > 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-danger btn-sm",
                        onClick: ($event: any) => (_ctx.removePiece(index))
                      }, " Supprimer ", 8, _hoisted_16))
                    : (_openBlock(), _createElementBlock("span", _hoisted_17, "—"))
                ])
              ]))
            }), 128)),
            (_ctx.pieces.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, " Aucun document ajouté. Cliquez sur \"Ajouter une pièce\" pour commencer. "))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.documentManquant.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _cache[12] || (_cache[12] = _createTextVNode(" Documents obligatoires manquants : ", -1)),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeDocuments.filter(t => _ctx.documentManquant.includes(t.value)), (type) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: type.value
                  }, _toDisplayString(type.label), 1))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_router_link, {
            to: { name: 'AddBlStep2', params: { id: _ctx.bescId } },
            class: "btn btn-danger px-4"
          }, {
            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
              _createTextVNode(" Retour à l'étape 2 ", -1)
            ]))]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToRecap && _ctx.goToRecap(...args))),
            class: "btn px-5 py-2 text-white",
            style: {"background-color":"#0a59a4","border":"none"},
            disabled: _ctx.pieces.length === 0 || !_ctx.hasAllDocuments
          }, " Valider & continuer ", 8, _hoisted_21)
        ])
      ])
    ]),
    (_ctx.showPaymentModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22))
      : _createCommentVNode("", true),
    (_ctx.showPaymentModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _cache[15] || (_cache[15] = _createElementVNode("h2", null, " Finaliser votre BESC", -1)),
                  _cache[16] || (_cache[16] = _createElementVNode("p", null, "Paiement sécurisé et rapide", -1)),
                  _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.formatEuro(_ctx.facture?.montantTotal || 0)), 1)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("h6", _hoisted_31, " Facture : " + _toDisplayString(_ctx.facture?.referenceFacture), 1),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("p", _hoisted_34, [
                          _cache[17] || (_cache[17] = _createElementVNode("strong", null, "Montant HT :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.formatEuro(_ctx.facture?.subtotalAmount)), 1)
                        ]),
                        _createElementVNode("p", _hoisted_35, [
                          _cache[18] || (_cache[18] = _createElementVNode("strong", null, "TVA (18%) :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.formatEuro(_ctx.facture?.taxAmount)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("p", _hoisted_37, [
                          _cache[19] || (_cache[19] = _createElementVNode("strong", null, "Échéance :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.facture?.dueDate)), 1)
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.prepaidAccount)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _cache[20] || (_cache[20] = _createElementVNode("strong", null, "Solde disponible :", -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.formatEuro(_ctx.prepaidAccount.balance)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _cache[28] || (_cache[28] = _createElementVNode("div", { class: "payment-methods-title" }, " Choisissez votre moyen de paiement ", -1)),
                  _createElementVNode("div", _hoisted_39, [
                    (_ctx.prepaidAccount && _ctx.prepaidAccount.balance >= _ctx.facture?.montantTotal)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "payment-method-card recommended",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.payWithPrepaidAccount && _ctx.payWithPrepaidAccount(...args))),
                          style: {"cursor":"pointer"}
                        }, [
                          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "payment-icon-wrapper" }, [
                            _createElementVNode("i", { class: "fa fa-wallet fa-3x text-primary" })
                          ], -1)),
                          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "payment-method-name" }, "Compte Prépayé", -1)),
                          _createElementVNode("div", _hoisted_40, "Solde : " + _toDisplayString(_ctx.formatEuro(_ctx.prepaidAccount.balance)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: "payment-method-card recommended",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.redirectToPaymentMethod('kkiapay'))),
                      style: {"cursor":"pointer"}
                    }, [...(_cache[23] || (_cache[23] = [
                      _createElementVNode("div", { class: "payment-icon-wrapper" }, [
                        _createElementVNode("img", {
                          src: "/kkiapay.png.webp",
                          alt: "KkiaPay",
                          style: {"width":"60px","height":"60px","object-fit":"contain"}
                        })
                      ], -1),
                      _createElementVNode("div", { class: "payment-method-name" }, "KkiaPay", -1),
                      _createElementVNode("div", { class: "payment-method-desc" }, "MTN • Moov • Carte", -1)
                    ]))]),
                    _createElementVNode("div", {
                      class: "payment-method-card",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.redirectToPaymentMethod('paypal'))),
                      style: {"cursor":"pointer"}
                    }, [...(_cache[24] || (_cache[24] = [
                      _createElementVNode("div", { class: "payment-icon-wrapper" }, [
                        _createElementVNode("img", {
                          src: "/paypal.png.png",
                          alt: "PayPal",
                          style: {"width":"60px","height":"60px","object-fit":"contain"}
                        })
                      ], -1),
                      _createElementVNode("div", { class: "payment-method-name" }, "PayPal", -1),
                      _createElementVNode("div", { class: "payment-method-desc" }, "Compte PayPal", -1)
                    ]))]),
                    _createElementVNode("div", {
                      class: "payment-method-card",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.redirectToPaymentMethod('stripe'))),
                      style: {"cursor":"pointer"}
                    }, [...(_cache[25] || (_cache[25] = [
                      _createElementVNode("div", { class: "payment-icon-wrapper" }, [
                        _createElementVNode("img", {
                          src: "/stripe.png.png",
                          alt: "Stripe",
                          style: {"width":"60px","height":"60px","object-fit":"contain"}
                        })
                      ], -1),
                      _createElementVNode("div", { class: "payment-method-name" }, "Carte Bancaire", -1),
                      _createElementVNode("div", { class: "payment-method-desc" }, "Visa • Mastercard", -1)
                    ]))])
                  ]),
                  (_ctx.prepaidAccount && _ctx.prepaidAccount.balance < _ctx.facture?.montantTotal)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _createElementVNode("small", null, [
                          _cache[26] || (_cache[26] = _createElementVNode("i", { class: "fa fa-info-circle me-1" }, null, -1)),
                          _createTextVNode(" Manquant : " + _toDisplayString(_ctx.formatEuro(_ctx.facture.montantTotal - _ctx.prepaidAccount.balance)), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-secondary btn-lg",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.cancelPayment && _ctx.cancelPayment(...args)))
                    }, [...(_cache[27] || (_cache[27] = [
                      _createElementVNode("i", { class: "fa fa-times me-2" }, null, -1),
                      _createTextVNode(" Annuler et revenir à la liste ", -1)
                    ]))])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSuccessModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_43))
      : _createCommentVNode("", true),
    (_ctx.showSuccessModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _cache[31] || (_cache[31] = _createElementVNode("div", {
                class: "modal-header",
                style: {"background-color":"#28a745"}
              }, [
                _createElementVNode("h5", { class: "modal-title text-white" }, [
                  _createElementVNode("i", { class: "fa fa-check-circle me-2" }),
                  _createTextVNode(" Paiement confirmé ! ")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_47, [
                _cache[30] || (_cache[30] = _createElementVNode("p", { class: "mb-4" }, [
                  _createTextVNode("Votre paiement a été confirmé avec succès."),
                  _createElementVNode("br"),
                  _createTextVNode("Imprimez vos documents maintenant :")
                ], -1)),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-success btn-lg",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.printBESC && _ctx.printBESC(...args))),
                    disabled: _ctx.printingBESC
                  }, [
                    (_ctx.printingBESC)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_50))
                      : (_openBlock(), _createElementBlock("i", _hoisted_51)),
                    _createTextVNode(" " + _toDisplayString(_ctx.printingBESC ? 'Préparation de l\'impression...' : 'Imprimer le BESC'), 1)
                  ], 8, _hoisted_49),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-info btn-lg text-white",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.printFacture && _ctx.printFacture(...args))),
                    disabled: _ctx.printingFacture
                  }, [
                    (_ctx.printingFacture)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_53))
                      : (_openBlock(), _createElementBlock("i", _hoisted_54)),
                    _createTextVNode(" " + _toDisplayString(_ctx.printingFacture ? 'Préparation de l\'impression...' : 'Imprimer la facture'), 1)
                  ], 8, _hoisted_52),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-primary btn-lg",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.goToList && _ctx.goToList(...args)))
                  }, [...(_cache[29] || (_cache[29] = [
                    _createElementVNode("i", { class: "fa fa-list me-2" }, null, -1),
                    _createTextVNode(" Voir la liste des BESC ", -1)
                  ]))])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}